export type ActionType =
  | 'SET_ORDER_CONFIRMATION_DATA'
  | 'REQUEST_ORDER_CONFIRMATION_DATA'
  | 'RECEIVED_ORDER_CONFIRMATION_DATA'
  | 'ERROR_ORDER_CONFIRMATION_DATA';

interface ActionProps {
  type: ActionType;
  isFetching?: boolean;
  data?: {} | any;
  error?: any;
  payload?: {} | any;
}

const initialOrderConfirmationState = {
  isFetching: true,
  data: {},
  error: {},
};

const OrderConfirm = (
  state = initialOrderConfirmationState,
  action: Partial<ActionProps>,
) => {
  switch (action.type) {
    case 'REQUEST_ORDER_CONFIRMATION_DATA': {
      return {
        ...state,
      };
    }

    case 'RECEIVED_ORDER_CONFIRMATION_DATA': {
      const { payload = {} } = action;
      return {
        ...state,
        isFetching: false,
        data: { ...payload },
      };
    }

    case 'ERROR_ORDER_CONFIRMATION_DATA': {
      const { error = {} } = action;
      return {
        ...state,
        isFetching: false,
        error: { ...error },
      };
    }

    default:
      return state;
  }
};

export default OrderConfirm;
